<template>
  <img :src="src()" :class="cssClass" alt="">
</template>

<script>
  export default {
    name: 'UserPhoto',
    props: {
      user: {
        required: true
      },
      cssClass:{
        default: 'mx-auto'
      }
    },
    methods: {
      src() {
        if (this.user.faces) {
          const count = this.user.faces.length;

          if (count) {
            return this.user.faces[count - 1].image_path;
          }
        }

        return require('../.././assets/images/user_placeholder.png');
      }
    }
  }
</script>
